import {ModeSettingEnum} from '@colonist/game-base-types'
import {ClientUserState} from '../ClientUserState.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'

export interface UISessionRecorderIdentifiers {
    context: string
}

export class UISessionRecorder {
    private readonly APP_ID: string = '1epp9p7e'
    private readonly FRAME_RATE: number = 5
    private readonly RESOLUTION: number = 720

    private readonly RECORDING_LIMIT_PER_MONTH: number = 500
    private readonly AVG_BEGINNER_MODE_USERS_PER_MONTH: number = 16000
    private readonly OUR_CURRENT_USAGE: number = this.AVG_BEGINNER_MODE_USERS_PER_MONTH // Add to this number as we use recorder in more places

    private readonly DISCORD_SCRIPT_PROXY_URL: string = '/.proxy/highlight-static/v8.9.1/index.js'
    private readonly DISCORD_BACKEND_PROXY_URL: string = '/.proxy/highlight-pub'

    private readonly RECORDER_OPTIONS = {
        enableCanvasRecording: true,
        samplingStrategy: {
            canvas: this.FRAME_RATE,
            canvasMaxSnapshotDimension: this.RESOLUTION,
        },
        environment: UIUtilsEjsVariables.isProduction ? 'production' : 'test',
        version: UIUtilsEjsVariables.versionNumber.toString(),
        networkRecording: {
            enabled: true,
            recordHeadersAndBody: true,
            urlBlocklist: [],
        },
        scriptUrl: UIUtilsEjsVariables.isUserOnDiscord ? this.DISCORD_SCRIPT_PROXY_URL : undefined,
        backendUrl: UIUtilsEjsVariables.isUserOnDiscord ? this.DISCORD_BACKEND_PROXY_URL : undefined,
    }

    private shouldRecordThisSession: boolean
    private highlightController: any

    constructor() {
        this.shouldRecordThisSession = this.getShouldRecordThisSession()
    }

    private async init() {
        if(!this.shouldRecordThisSession) return
        if(this.highlightController != undefined) return
        try {
            const highlight = await import('highlight.run')
            this.highlightController = highlight.H
        } catch(e) {
            // eslint-disable-next-line no-console
            console.error('Failed to load highlight.run', e)
            this.shouldRecordThisSession = false
        }
    }

    // eslint-disable-next-line class-methods-use-this
    async conditionallyStartRecording(modeSetting: ModeSettingEnum) {
        if(modeSetting != ModeSettingEnum.ColonistRush4P) return
        // TODO: Uncomment this when the canvas recording in highlight.io is fixed
        // await this.startRecording({context: 'ColonistRush'})
    }

    private async startRecording(sessionIdentifiers: UISessionRecorderIdentifiers) {
        await this.init()
        if(this.highlightController == undefined) return

        this.highlightController.init(this.APP_ID, this.RECORDER_OPTIONS)
        this.highlightController.identify(ClientUserState.userState?.id, {
            context: sessionIdentifiers.context,
        })
    }

    stopRecording() {
        if(this.highlightController == undefined) return
        this.highlightController.stop()
    }

    private getShouldRecordThisSession(): boolean {
        if(!UIUtilsEjsVariables.isProduction) return false

        const shouldRecordThisSession = Math.random() < this.RECORDING_LIMIT_PER_MONTH / this.OUR_CURRENT_USAGE
        return shouldRecordThisSession
    }
}
